import React from 'react';
import styled from "styled-components"
import {
  SkipLink,
} from 'govuk-react';

import {
  BrowserRouter as Router,
  Route,
  Link,
} from "react-router-dom";


import {Container} from "./theme/elements";
import CookiesMessage  from './components/CookiesMessage'
import Header  from './components/Header'
import Footer  from './components/Footer'
// import PageHeader from './components/PageHeader';

//pages
import HomePage from './pages/HomePage.js';
import ExampleOnePage from './pages/ExampleOnePage';
import ExampleTwoPage from './pages/ExampleTwoPage';
import ExampleTreePage  from './pages/ExampleTreePage'
import CustomElementsOne from './pages/CustomElementsOne';
import CustomElementsTwo from './pages/CustomElementsTwo';


const MainWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
`

const Main = styled.main`
  ol {
    margin: 20px 0 0;
    list-style-type: none;
    display: block;
    
    li {
        display: inline-block;
        position: relative;
        margin-bottom: 5px;
       
        a {
            text-decoration: none;
            
            &:focus {
                border-bottom: 3px solid #ffdd00;
                outline-offset: 0;
            }
        }
    
        &:not(:first-child) {
          margin-left: 10px;
          padding-left: 15.655px;
          &::before {
                content: "";
                display: block;
                position: absolute;
                top: -1px;
                bottom: 1px;
                left: -3.31px;
                width: 7px;
                height: 20px;
                margin: auto 0;
                border-style: solid;
                border-image: initial;
                border-width: 0 1px 0 0;
                border-color: rgb(111, 119, 123);
          }
        }
       
    }
`

const App = () => {

  return (
      <>
        <SkipLink href="#main-content">Skip to main content</SkipLink>
        <CookiesMessage />
        <Header/>

          {/*<PageHeader />*/}
          <MainWrapper>
              <Main role="main" id="main-content">
                  <Router>
                      <ol>
                          <li>
                              <Link to="/">Home</Link>
                          </li>
                          <li>
                              <Link to="/ExampleOnePage">Page Example 1</Link>
                          </li>
                          <li>
                              <Link to="/ExampleTwoPage">Page Example  2</Link>
                          </li>
                          <li>
                              <Link to="/ExampleTreePage">Page Example 3</Link>
                          </li>
                          <li>
                              <Link to="/CustomElementsOne">Page Custom 1</Link>
                          </li>
                          <li>
                              <Link to="/CustomElementsTwo">Page Custom 2</Link>
                          </li>
                      </ol>

                      <Route exact path="/" component={HomePage} />
                      <Route path="/ExampleOnePage" component={ExampleOnePage} />
                      <Route path="/ExampleTwoPage" component={ExampleTwoPage} />
                      <Route path="/ExampleTreePage" component={ExampleTreePage} />
                      <Route path="/CustomElementsOne" component={CustomElementsOne} />
                      <Route path="/CustomElementsTwo" component={CustomElementsTwo} />
                  </Router>
              </Main>
          </MainWrapper>
        <Footer/>
      </>
  )
};

export default App;


